import React, {Component} from 'react';
import {
    PanelContainer,
    Panel,
    PanelHeader,
    PanelBody
} from '@sketchpixy/rubix'


class ReflexExamScale extends Component {
    constructor(props) {
        super(props)
        
        this.state = {
            rules : props.rules
        }
        
    }
    
    render() {
        let { rules } = this.state;
        const {
            onClose
          } = this.props

        return (
            <div className="overlay-legend-reflex" onClick={e => {onClose(e)}}> 
                {/* <div className="animate__animated animate__fadeInDown"> */}
                    {rules.map((question, i) => 
                        
                        <div key={"selectFieldfirstDiv"+i}>
                            <PanelContainer containerClasses="rubix-panel-container-with-bottom-shadow">
                                <Panel>
                                    <PanelHeader className="row">                            
                                            <div className='rms-legend-heading'>{question.label}</div>           
                                    </PanelHeader>
                                    <PanelBody className="selectbox-body">
                                        <PanelContainer >
                                            <Panel>
                                                <PanelBody className="selectbox-bodyinner">
                                                    <div className="row select-question-padding-left" >
                                                    {question.options.map((optn, index) => <div key={"selectFieldDiv"+index}  className="col-md-12 mp-0 text-left" >
                                                        <label  className="col-sm-1"></label>
                                                        <label  className="col-sm-1 selectbox-label mp-0" style={{color: '#079EDA', fontWeight: 'bold'}}>{optn.main}</label>
                                                        <label  className="col-sm-8 selectbox-label">{optn.sub}</label>
                                                    

                                                    </div>)}
                                                    </div>
                                                </PanelBody>
                                            </Panel>
                                        </PanelContainer>
                                    </PanelBody>
                                </Panel>
                            </PanelContainer>
                        </div>                        
                    )}
                </div>
        );
    }
}

export default ReflexExamScale